import { Route, NavigationGuardNext } from 'vue-router';
import { Routes } from '@front-app/constants/routes';
import Home from '../views/Home.vue';
import { publicRoutes } from './routes/public';
import { userRoutes } from './routes/user';
import { eventRoutes } from './routes/event';
import { PhoenixRouteConfig } from './Model';
import { csrRoutes } from './routes/csr';
import { communityRoutes } from './routes/community';
import { groupRoutes } from './routes/group';

// All routes should have a meta.title function, these will be concatenated to form the
// document title on route changes
export const routes: PhoenixRouteConfig[] = [
	{
		meta: { title(): string { return 'TimedRight'; } },
		path: '/',
		name: Routes.HOME,
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		component: Home,
		async beforeEnter(to: Route, from: Route, next: NavigationGuardNext): Promise<void> {
			if (to.name && to.name === Routes.HOME) {
				next({ name: Routes.GROUPS });
			} else {
				next();
			}
		},
		children: [
			...userRoutes,
			...csrRoutes,
			...communityRoutes,
			...groupRoutes,
			...eventRoutes,
		],
	},
	...publicRoutes,
];
